import { useEffect, useRef } from 'react';
import { fetchPostQuery } from '/src/api';
import { useStoreConfigContext } from '/src/providers';
import { getCookie, setCookie } from '/src/utils';
import { COOKIE_CONSENT} from '/src/consts';

const ACTIVITIES_UID = 'activities_uid';

const generateHash = length => {
    let result = '';
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for (let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.random() * charactersLength);
    }
    return result;
};

const initActivities = (cookieLifetime, ref) => {
    const activitiesTime = new Date(new Date().getTime() - ref.current).getMinutes();

    if (!getCookie(ACTIVITIES_UID)) {
        setCookie(ACTIVITIES_UID, generateHash(24), cookieLifetime);
    }

    if (activitiesTime < 1 && getCookie(COOKIE_CONSENT)) {
        fetchPostQuery({
            query: `mutation UpdateConsentPermission($input: UpdateConsentPermissionInput!) { UpdateConsentPermission(input: $input) }`,
            variables: {
                input: {
                    hash: getCookie(ACTIVITIES_UID),
                    cookie_consent: getCookie(COOKIE_CONSENT),
                }
            }
        }).catch(() => {});
    }
};

const useUserActivitiesAndSelectedConsents = () => {
    const {
        storeConfig: {
            cookieconsent_update_interval,
            cookieconsent_cookie_lifetime,
        }
    } = useStoreConfigContext();
    const ref = useRef(new Date().getTime());

    const timeInterval = cookieconsent_update_interval < 60000 ? 60000 : cookieconsent_update_interval;

    useEffect(() => {
        let handleCheckActivities = null;

        function handleClick() {
            ref.current = new Date().getTime();
        }

        document.addEventListener('click', handleClick);

        initActivities(cookieconsent_cookie_lifetime, ref);

        handleCheckActivities = setInterval(() => {
            initActivities(cookieconsent_cookie_lifetime, ref);
        }, timeInterval);

        return () => {
            document.removeEventListener('click', handleClick);
            clearInterval(handleCheckActivities);
        };
    }, []);
};

export default useUserActivitiesAndSelectedConsents;
